import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Comparison panel art: the period matrix the panel really is. A label
 * column, then one column per period (the first in the accent as the
 * baseline), and in every cell a value bar with a small green or red delta
 * chip at its right end.
 */
const PERIOD_X = [48, 84, 120]
const ROW_Y = [32, 46, 60, 74]
/** Per row, per period: delta up? */
const DELTAS: boolean[][] = [
  [true, true, false],
  [true, false, true],
  [false, true, true],
  [true, false, false],
]
const LABEL_WIDTHS = [22, 18, 26, 20]

export function ComparisonArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      {/* Period headers; the first is the baseline. */}
      {PERIOD_X.map((x, i) => (
        <rect
          key={x}
          x={x}
          y={12}
          width={28}
          height={7}
          rx={3}
          fill={i === 0 ? 'hsl(var(--primary) / 0.55)' : 'hsl(var(--foreground) / 0.16)'}
        />
      ))}
      <path
        d="M12 25 H148"
        stroke="hsl(var(--muted-foreground) / 0.3)"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
      />
      {/* Faint column separators so the grid reads before the content. */}
      <path
        d="M44 28 V84 M80 28 V84 M116 28 V84"
        stroke="hsl(var(--muted-foreground) / 0.15)"
        strokeWidth="1"
        vectorEffect="non-scaling-stroke"
      />
      {ROW_Y.map((y, row) => (
        <g key={y}>
          <rect
            x={12}
            y={y + 1}
            width={LABEL_WIDTHS[row]}
            height={4}
            rx={2}
            fill="hsl(var(--foreground) / 0.2)"
          />
          {PERIOD_X.map((x, col) => (
            <g key={x}>
              <rect x={x} y={y} width={17} height={6} rx={2} fill="hsl(var(--foreground) / 0.26)" />
              <rect
                x={x + 20}
                y={y + 1}
                width={8}
                height={4}
                rx={2}
                fill={
                  DELTAS[row][col] ? 'hsl(var(--positive) / 0.55)' : 'hsl(var(--negative) / 0.55)'
                }
              />
            </g>
          ))}
        </g>
      ))}
    </svg>
  )
}
